import { post } from "../utils";

export default host => (token) =>
  post(`${host}/gift/${token}/claim`, {})
